module.exports = __webpack_public_path__ + "img/onboarding_runningman.d273687e.png";